// Spunt × Lovin Malta — Fantasy Election League promo strip.
//
// Static responsive banner occupying the dashboard's "strip" slot
// (previously the hunch.mt quick-polls embed). No iframe, no live
// data, no scripts — a plain link-out to spunt.mt with UTM tags
// baked into the URL.
//
// The whole strip is clickable: the visible "Play free" button is
// the single real <a>, and a stretched ::before pseudo-element
// (see SpuntStripBanner.css) extends its hit area over the entire
// banner. No nested anchors, no JS click handlers.
//
// Artwork: a transparent-background PNG that must be dropped at
// public/assets/FEL-strip-artwork.png — it sits directly on the
// gradient, no white box.

import './SpuntStripBanner.css';

const SPUNT_URL =
  'https://www.spunt.mt/fantasy-election-league?utm_source=lovinmalta&utm_medium=strip&utm_campaign=fel2026';

export default function SpuntStripBanner() {
  return (
    <div className="spunt-strip">
      <div className="spunt-strip__inner">
        <div className="spunt-strip__text">
          <p className="spunt-strip__headline">
            Fantasy football,
            <br />
            for the election
          </p>
          <p className="spunt-strip__sub">
            Pick 13 candidates. Captain one.
            <br />
            Score when the votes are counted.
          </p>
          <a
            className="spunt-strip__btn"
            href={SPUNT_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Play the Spunt Fantasy Election League — free"
          >
            Play free
          </a>
        </div>
        {/* Co-brand lockup — sits in the gutter between the text
            and the artwork, vertically centred. */}
        <div className="spunt-strip__logo-slot">
          <img
            className="spunt-strip__logo"
            src="/assets/spunt-lovin-logo.png"
            alt="Spunt × Lovin Malta"
            loading="lazy"
          />
        </div>
        <div className="spunt-strip__art">
          <img
            src="/assets/FEL-strip-artwork.png"
            alt="Spunt Fantasy Election League"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
